import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { __rest } from '../../_virtual/_tslib.js';
import React from 'react';
import { fragmentMap } from '../../utils/ReactUtils.js';
import { CardsPresentation } from './CardsPresentation.js';

var CardsWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(CardsWrapper, _React$Component);
  var _super = _createSuper(CardsWrapper);
  function CardsWrapper(props) {
    var _this;
    _classCallCheck(this, CardsWrapper);
    _this = _super.call(this, props);
    _this.state = {};
    return _this;
  }
  _createClass(CardsWrapper, [{
    key: "render",
    value: function render() {
      var _a = this.props,
        children = _a.children,
        itemsPerRow = _a.itemsPerRow,
        otherProps = __rest(_a, ["children", "itemsPerRow"]);
      return /*#__PURE__*/React.createElement(CardsPresentation, Object.assign({}, otherProps), fragmentMap(children, function (child) {
        return /*#__PURE__*/React.cloneElement(child, {
          itemsPerRow: itemsPerRow
        });
      }));
    }
  }]);
  return CardsWrapper;
}(React.Component);
CardsWrapper.defaultProps = {
  itemsPerRow: 4
};

export { CardsWrapper };
